export const PERSONA_ARRAY = ['InFlight', 'Operations'] as const;
export const DEFAULT_PERSONA: Persona = 'InFlight';

export type Persona = (typeof PERSONA_ARRAY)[number];
